import {
  AbsoluteCenter,
  Box,
  Button,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import React from "react";
import { useTranslation } from "react-i18next";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { HIDE_MAINTAIN_ALERT } from "../../redux/action/member/memberAction";
import CommonModal from "../Common/CommonModal";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const MaintainAlertModal = () => {
  const { t } = useTranslation();
  const i18n_common = (key, props) => t(`common.${key}`, { ...props });

  const dispatch = useDispatch();
  const isMaintainAlert = useSelector((state) => state.isMaintainAlert);

  const handleConfirm = () => {
    dispatch(HIDE_MAINTAIN_ALERT());
  };

  return (
    isMaintainAlert?.state && (
      <CommonModal bgNone>
        <Box
          onClick={handleConfirm}
          position="absolute"
          top="-40px"
          right="0px"
          w="30px"
          h="30px"
          bgImage={`url('${COMMON_WEB_PATH}/theOne/modal/close_icon.png')`}
          bgSize="100% 100%"
          bgPos="center"
          cursor="pointer"
        ></Box>
        <Box fontSize="24px" color="white" textAlign="center" mb={2}>
          {i18n_common("維護通知", {
            maintainTime: isMaintainAlert?.maintainTime,
          })}
        </Box>
        <Flex gap={4} mb={4} justifyContent="space-between" alignItems="center">
          <Button
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/theOne/button/confirm_background.png)`,
              bgSize: "contain",
              bgRepeat: "no-repeat",
              bgPosition: "center",
              background: "transparent",
              _hover: {
                bgImage: `url(${COMMON_WEB_PATH}/theOne/button/confirm_background.png)`,
              },
              _active: {
                bgImage: `url(${COMMON_WEB_PATH}/theOne/button/confirm_background.png)`,
              },
              h: "65px",
            }}
            onClick={handleConfirm}
            py="20px"
            type="submit"
            w="130px"
          >
            <Text mb="5px" color="#0C5426" fontWeight={900} fontSize="23px">
              {i18n_common("confirm")}
            </Text>
          </Button>
        </Flex>
      </CommonModal>
    )
  );
};

export default MaintainAlertModal;
